import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class FakDokumentView extends BaseEntity{

    constructor(){
        super();
    }
    
    PodVrstaDokumentaStavkaID:number;
    PodVrstaDokumentaStavka: string;
    Komitent: string; 
    KomitentMesto: string; 
    BrojDokumenta: string;
    Datum: NgbDate;    
    Ukupno: number;
    StatusGenericName: string;
    StatusColor:string;
    StatusTooltip:string;
    ProvajderID:number;
    OsvezivogStatusa:boolean;
    MasterDokumID: number;
    DatDpo: NgbDate;
    UlaziUSumu: boolean;
    VezanZaPpp: boolean;
    VezanZaPppTooltip: string;
    TipDokumentaNaziv: string;
    BrojDecimala: string;
    Komentar: string;
    UkupnoAvansi: number;
    Izvodi: number ;
    Naplaceno: number ;
    ZaUplatu: number ;
    GenericName: string;
    RokDana: number;

    Deserialize(input: any){
        this.ID = input.ID;
        this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
        this.PodVrstaDokumentaStavka = input.PodVrstaDokumentaStavka;
        this.Komitent = input.Komitent;
        this.KomitentMesto = input.KomitentMesto;
        this.BrojDokumenta = input.BrojDokumenta;
        this.Datum = input.Datum;
        this.Ukupno = input.Ukupno;
        this.StatusGenericName = input.StatusGenericName;
        this.StatusColor=input.StatusColor;
        this.StatusTooltip= input.StatusTooltip;
        this.ProvajderID=input.ProvajderID;
        this.OsvezivogStatusa=input.OsvezivogStatusa;
        this.MasterDokumID=input.MasterDokumID;
        this.DatDpo = input.DatDpo;
        this.UlaziUSumu=input.UlaziUSumu;
        this.VezanZaPpp = input.VezanZaPpp;
        this.VezanZaPppTooltip = input.VezanZaPppTooltip;
        this.TipDokumentaNaziv = input.TipDokumentaNaziv;
        this.BrojDecimala = input.BrojDecimala;
        this.Komentar = input.Komentar;
        this.UkupnoAvansi = input.UkupnoAvansi;
        this.Izvodi = input.Izvodi;
        this.Naplaceno = input.Naplaceno;
        this.ZaUplatu = input.ZaUplatu;
        this.GenericName = input.GenericName;
        this.RokDana = input.RokDana;

        
        return this;
    }

    Serialize(input: FakDokumentView){
        return input;
    }
}
